import UserProfile from "../components/configuration/users/userProfile/UserProfile"

const UserProfilePage = ()=>{

 return(
    <>
      <UserProfile />
    </>
 )

 
}

export default UserProfilePage;